'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFileUpload = require('./CwFileUpload.scss');

var _CwFileUpload2 = _interopRequireDefault(_CwFileUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFileUpload = function (_Component) {
  (0, _inherits3.default)(CwFileUpload, _Component);

  function CwFileUpload() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwFileUpload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwFileUpload.__proto__ || (0, _getPrototypeOf2.default)(CwFileUpload)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (_this.props.disabled) {
        return;
      }

      // https://stackoverflow.com/questions/12030686/html-input-file-selection-event-not-firing-upon-selecting-the-same-file
      _this.inputField.value = null; // trigger onchange event if same file is selected

      _this.inputField.click(); // emulate clicking the hidden file input
    }, _this.handleFileChange = function (event) {
      // Update
      if (!event.target.files || event.target.files.length < 1) {
        return;
      }
      var files = event.target.files;

      if (_this.props.onFileChanged) {
        _this.props.onFileChanged(files);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwFileUpload, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { onClick: this.handleClick, className: this.props.className, style: this.props.style },
        _react2.default.createElement('input', {
          className: _CwFileUpload2.default.file,
          accept: this.props.accept,
          type: 'file',
          tabIndex: '-1',
          ref: function ref(input) {
            return _this2.inputField = input;
          },
          onChange: this.handleFileChange,
          multiple: this.props.multiple
        }),
        this.props.children
      );
    }
  }]);
  return CwFileUpload;
}(_react.Component);

CwFileUpload.propTypes = {
  /**
   * Determines which file types can be uploaded
   * accepts file extensions, media types, and 
   * audio/*|video/*|image/*
   */
  accept: _propTypes2.default.string,
  /**
   * Allows multiple file upload if true
   */
  multiple: _propTypes2.default.bool,
  /**
   * Controls whether the file upload is disabled
   */
  disabled: _propTypes2.default.bool,
  /**
   * Callback fired when a new file is selected
   */
  onFileChanged: _propTypes2.default.func,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
  * The css class name to be appended to default classname
  */
  className: _propTypes2.default.string
};

CwFileUpload.defaultProps = {
  accept: ''
};

exports.default = CwFileUpload;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwfileupload/CwFileUpload.js
// module id = 368
// module chunks = 10